import { isDone } from './is-done';

export function createVueComponent({ elementId, component, props }) {
    isDone().then(() => {
        new window.Vue({
            el: `#${elementId}`,
            render: h => h(component, { props })
        });
    });
}